import { useEffect, useState } from "react";
import { adminFetch } from "../adminApi";
import { SiteContent, PasswordForm } from "./sections";
import { LOGO_URL } from "@/data";

/* প্রশাসক-নিয়ন্ত্রণ কক্ষ — হালকা, পরিষ্কার, বাংলালি ছোঁয়া; ERP নয় */

const card = "rounded-2xl border border-[#e6dcc8] bg-white shadow-[0_2px_14px_rgba(61,44,30,0.06)]";
const input = "mt-1 w-full rounded-lg border border-[#e0d4bc] bg-[#fdfaf4] px-3 py-2 text-sm text-dusk outline-none transition-colors focus:border-gold";
const btn = "rounded-full px-4 py-2 text-xs font-medium transition-all duration-300 disabled:opacity-40";

export function Pill({ s }) {
  const m = {
    "প্রাণবন্ত": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "যাচাইকৃত": "bg-amber-100 text-amber-800 border-amber-200",
    "অপেক্ষমাণ": "bg-orange-100 text-orange-800 border-orange-200",
    "স্থগিত": "bg-red-100 text-red-700 border-red-200",
    "লুকানো": "bg-stone-200 text-stone-600 border-stone-300",
    "খসড়া": "bg-stone-200 text-stone-600 border-stone-300",
    "লাইভ": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "চালু": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "বন্ধ": "bg-red-100 text-red-700 border-red-200",
    "নিশ্চিত": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "সম্পন্ন": "bg-emerald-100 text-emerald-800 border-emerald-200",
    "বাতিল": "bg-red-100 text-red-700 border-red-200",
  };
  return <span className={`rounded-full border px-3 py-1 text-[11px] ${m[s] || "bg-stone-100 text-stone-600 border-stone-200"}`} data-testid={`pill-${s}`}>{s}</span>;
}

export function Loading() {
  return <p className="text-sm text-stone-500">লোড হচ্ছে…</p>;
}

export function Empty({ text }) {
  return <p className="rounded-xl border border-dashed border-[#e0d4bc] bg-[#fdfaf4] p-6 text-center text-sm text-stone-500">{text}</p>;
}

function useList(url) {
  const [d, setD] = useState(null);
  const load = () => adminFetch(url).then(setD).catch(() => setD({ items: [] }));
  useEffect(() => { load(); }, [url]);
  return [d, load];
}

function Toolbar({ q, setQ, children }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        value={q} onChange={(e) => setQ(e.target.value)} placeholder="খুঁজুন…"
        data-testid="admin-search"
        className="w-full max-w-xs rounded-full border border-[#e0d4bc] bg-[#fdfaf4] px-4 py-2 text-sm text-dusk outline-none focus:border-gold"
      />
      {children}
    </div>
  );
}

const sel = "rounded-full border border-[#e0d4bc] bg-[#fdfaf4] px-3 py-2 text-xs text-dusk outline-none";

/* ---------- এক-নজরে ---------- */
export function Overview({ go }) {
  const [d, setD] = useState(null);
  useEffect(() => { adminFetch("/admin/overview").then(setD).catch(() => {}); }, []);
  if (!d) return <Loading />;
  const cards = [
    { k: "creators", label: "ক্রিয়েটর", tab: "creators", t: "ov-creators" },
    { k: "live_shops", label: "প্রাণবন্ত দোকান", tab: "shops", t: "ov-shops" },
    { k: "live_artists", label: "প্রাণবন্ত শিল্পী", tab: "artists", t: "ov-artists" },
    { k: "live_products", label: "পণ্য", tab: "products", t: "ov-products" },
    { k: "pending", label: "অপেক্ষমাণ-অনুমোদন", tab: "creators", hot: true, t: "ov-pending" },
    { k: "orders", label: "অর্ডার", tab: "orders", t: "ov-orders" },
    { k: "bookings", label: "বুকিং", tab: "bookings", t: "ov-bookings" },
    { k: "open_enquiries", label: "খোলা জিজ্ঞেস", tab: "enquiries", t: "ov-enquiries" },
  ];
  return (
    <div data-testid="admin-section-overview">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {cards.map((c) => (
          <button key={c.k} data-testid={c.t} onClick={() => go(c.tab)}
            className={`${card} p-5 text-left transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(61,44,30,0.12)] ${c.hot && d[c.k] > 0 ? "border-vermilion/50" : ""}`}>
            <p className={`font-display text-3xl ${c.hot && d[c.k] > 0 ? "text-vermilion" : "text-dusk"}`}>{d[c.k]}</p>
            <p className="mt-1 text-xs text-stone-500">{c.label}</p>
          </button>
        ))}
      </div>
      <p className="mt-6 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4 text-xs leading-relaxed text-stone-500">
        গ্রামের হিসাব-খাতা — বাঁ দিকের তালিকা থেকে সব ঘরে ঢুন। প্রতিটা গুরুত্বপূর্ণ হাত নিচের "কার্যক্রম-খাতায়" ওঠে।
      </p>
    </div>
  );
}

/* ---------- ক্রিয়েটর ---------- */
export function CreatorsTab({ goCustomer }) {
  const [q, setQ] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");
  const [d, load] = useList(`/admin/creators?q=${encodeURIComponent(q)}&type=${type}&status=${encodeURIComponent(status)}`);
  const [open, setOpen] = useState(null);
  const [busy, setBusy] = useState("");
  const [err, setErr] = useState("");

  const act = async (email, action) => {
    setBusy(email + action); setErr("");
    try {
      await adminFetch(`/admin/creators/${encodeURIComponent(email)}/action`, { method: "POST", body: JSON.stringify({ action }) });
      setOpen(null); load();
    } catch (e) { setErr(e.message); }
    setBusy("");
  };

  return (
    <div data-testid="admin-section-creators">
      <Toolbar q={q} setQ={setQ}>
        <select value={type} onChange={(e) => setType(e.target.value)} className={sel} data-testid="filter-creator-type">
          <option value="">সব ধরন</option><option value="artisan">শিল্পকার</option><option value="artist">লোকশিল্পী</option>
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={sel} data-testid="filter-creator-status">
          <option value="">সব অবস্থা</option><option value="অপেক্ষমাণ">অপেক্ষমাণ</option><option value="প্রাণবন্ত">প্রাণবন্ত</option><option value="স্থগিত">স্থগিত</option>
        </select>
      </Toolbar>
      {!d ? <Loading /> : d.items.length === 0 ? <Empty text="এই ছাঁকনিতে কেউ নেই।" /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((c) => (
            <div key={c.email} className={`${card} p-4 sm:p-5`} data-testid={`creator-row-${c.email}`}>
              <div className="flex flex-wrap items-center gap-4" role="button" onClick={() => setOpen(open === c.email ? null : c.email)}>
                {c.photo ? <img src={c.photo.startsWith("http") ? c.photo : `${process.env.REACT_APP_BACKEND_URL}${c.photo}`} alt="" className="h-12 w-12 rounded-full object-cover ring-2 ring-gold/40" />
                  : <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold/15 font-display text-lg text-dusk">{(c.name || "?")[0]}</span>}
                <div className="min-w-0 flex-1">
                  <p className="font-display text-lg text-dusk">{c.name || "(নাম নেই)"}</p>
                  <p className="truncate text-xs text-stone-500">{c.craft || (c.creator_type === "artist" ? "লোকশিল্পী" : "শিল্পকার")} • {c.location || "—"} • {c.email}</p>
                </div>
                <Pill s={c.status} />
              </div>
              {open === c.email && (
                <div className="mt-4 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4" data-testid="creator-detail">
                  <dl className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-sm sm:grid-cols-3">
                    <div><dt className="text-[11px] text-stone-400">ধরন</dt><dd className="text-dusk">{c.creator_type === "artist" ? "লোকশিল্পী" : "শিল্পকার"}</dd></div>
                    <div><dt className="text-[11px] text-stone-400">ঠিকানা</dt><dd className="text-dusk">{c.location || "—"}</dd></div>
                    <div><dt className="text-[11px] text-stone-400">যোগাযোগ</dt><dd className="truncate text-dusk">{c.contact || c.email}</dd></div>
                    <div><dt className="text-[11px] text-stone-400">যোগদান</dt><dd className="text-dusk">{(c.created_at || "").slice(0, 10) || "—"}</dd></div>
                    <div><dt className="text-[11px] text-stone-400">দোকান/মঞ্চ</dt><dd className="text-dusk">{c.shop_key || c.artist_id || "—"}</dd></div>
                    <div><dt className="text-[11px] text-stone-400">যাচাই</dt><dd className="text-dusk">{c.verified ? "যাচাইকৃত" : "বাকি"}</dd></div>
                  </dl>
                  <div className="mt-4 flex flex-wrap gap-2">
                    <button disabled={busy === c.email + "approve"} onClick={() => act(c.email, "approve")} className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid={`creator-approve-${c.email}`}>অনুমোদন</button>
                    <button disabled={busy === c.email + "reject"} onClick={() => act(c.email, "reject")} className={`${btn} border border-stone-300 text-stone-600 hover:bg-stone-100`} data-testid={`creator-reject-${c.email}`}>ফেরত পাঠান</button>
                    <button disabled={busy === c.email + "suspend"} onClick={() => act(c.email, "suspend")} className={`${btn} border border-red-300 text-red-600 hover:bg-red-50`} data-testid={`creator-suspend-${c.email}`}>স্থগিত</button>
                    <button disabled={busy === c.email + "reactivate"} onClick={() => act(c.email, "reactivate")} className={`${btn} border border-gold text-dusk hover:bg-gold hover:text-white`} data-testid={`creator-reactivate-${c.email}`}>আবার চালু</button>
                    {c.creator_type === "artist" && <button onClick={() => goCustomer("moncho", "রং ও মঞ্চ")} className={`${btn} bg-dusk text-sand`}>Stage দেখুন</button>}
                    {c.creator_type !== "artist" && <button onClick={() => goCustomer("hat", "রঙের হাট")} className={`${btn} bg-dusk text-sand`}>Shop দেখুন</button>}
                  </div>
                  {err && <p className="mt-2 text-xs text-red-600">{err}</p>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- দোকান ---------- */
export function ShopsTab({ goCustomer }) {
  const [q, setQ] = useState("");
  const [d, load] = useList(`/admin/shops?q=${encodeURIComponent(q)}`);
  const [edit, setEdit] = useState(null);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState("");

  const act = async (key, action) => {
    setBusy(key); try { await adminFetch(`/admin/shops/${key}/action`, { method: "POST", body: JSON.stringify({ action }) }); load(); } catch (e) { alert(e.message); } setBusy("");
  };
  const save = async () => {
    setBusy(edit);
    try {
      await adminFetch(`/admin/shops/${edit}`, { method: "PUT", body: JSON.stringify({ ...edit.source, ...f, key: edit }) });
      setEdit(null); load();
    } catch (e) { alert(e.message); }
    setBusy("");
  };

  return (
    <div data-testid="admin-section-shops">
      <Toolbar q={q} setQ={setQ} />
      {!d ? <Loading /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((s) => (
            <div key={s.key} className={`${card} p-4 sm:p-5`} data-testid={`shop-row-${s.key}`}>
              <div className="flex flex-wrap items-center gap-4">
                <img src={s.image?.startsWith("http") ? s.image : `${process.env.REACT_APP_BACKEND_URL}${s.image || ""}`} alt="" className="h-12 w-16 rounded-lg object-cover" />
                <div className="min-w-0 flex-1">
                  <p className="font-display text-lg text-dusk">{s.name}</p>
                  <p className="text-xs text-stone-500">{s.latin || s.key} • পণ্য {s.product_count}টি</p>
                </div>
                <Pill s={s.status} />
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                <button onClick={() => goCustomer("hat", "রঙের হাট")} className={`${btn} bg-dusk text-sand`} data-testid={`shop-view-${s.key}`}>View</button>
                {s.status === "প্রাণবন্ত"
                  ? <button disabled={busy === s.key} onClick={() => act(s.key, "suspend")} className={`${btn} border border-red-300 text-red-600 hover:bg-red-50`} data-testid={`shop-suspend-${s.key}`}>Suspend</button>
                  : <button disabled={busy === s.key} onClick={() => act(s.key, "approve")} className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid={`shop-approve-${s.key}`}>Approve</button>}
                <button onClick={() => { setEdit(edit === s.key ? null : s.key); setF({ name: s.name, latin: s.latin || "", blurb: s.blurb || "", image: s.image || "" }); }} className={`${btn} border border-gold text-dusk hover:bg-gold hover:text-white`} data-testid={`shop-edit-${s.key}`}>Edit</button>
              </div>
              {edit === s.key && (
                <div className="mt-4 grid gap-3 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4 sm:grid-cols-2" data-testid="shop-edit-form">
                  <label className="text-xs text-stone-500">নাম<input className={input} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></label>
                  <label className="text-xs text-stone-500">ইংরেজি পরিচয়<input className={input} value={f.latin} onChange={(e) => setF({ ...f, latin: e.target.value })} /></label>
                  <label className="text-xs text-stone-500 sm:col-span-2">পরিচয়-বাক্য<input className={input} value={f.blurb} onChange={(e) => setF({ ...f, blurb: e.target.value })} /></label>
                  <label className="text-xs text-stone-500 sm:col-span-2">ছবির ঠিকানা<input className={input} value={f.image} onChange={(e) => setF({ ...f, image: e.target.value })} /></label>
                  <button onClick={save} disabled={busy === s.key} className={`${btn} bg-vermilion text-white sm:col-span-2`} data-testid="shop-edit-save">সাধুন</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- পণ্য ---------- */
export function ProductsTab({ goCustomer }) {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [status, setStatus] = useState("");
  const [d, load] = useList(`/admin/products?q=${encodeURIComponent(q)}&category=${encodeURIComponent(cat)}&status=${encodeURIComponent(status)}`);
  const [edit, setEdit] = useState(null);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState("");

  const act = async (pid, action) => {
    setBusy(pid); try { await adminFetch(`/admin/products/${pid}/action`, { method: "POST", body: JSON.stringify({ action }) }); load(); } catch (e) { alert(e.message); } setBusy("");
  };
  const save = async () => {
    setBusy(edit);
    try {
      const src = edit.source;
      await adminFetch(`/admin/products/${edit}`, { method: "PUT", body: JSON.stringify({ ...src, title: f.title ?? src.title, price: f.price ?? src.price, price_num: Number(f.price_num ?? src.price_num) || 0 }) });
      setEdit(null); load();
    } catch (e) { alert(e.message); }
    setBusy("");
  };

  const cats = d ? [...new Set(d.items.map((p) => p.craft).filter(Boolean))] : [];
  return (
    <div data-testid="admin-section-products">
      <Toolbar q={q} setQ={setQ}>
        <select value={cat} onChange={(e) => setCat(e.target.value)} className={sel} data-testid="filter-product-category">
          <option value="">সব ঘরানা</option>{cats.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className={sel} data-testid="filter-product-status">
          <option value="">সব অবস্থা</option><option value="লাইভ">লাইভ</option><option value="লুকানো">লুকানো</option><option value="খসড়া">খসড়া</option><option value="অপেক্ষমাণ">অপেক্ষমাণ</option>
        </select>
      </Toolbar>
      {!d ? <Loading /> : d.items.length === 0 ? <Empty text="কোনো পণ্য নেই।" /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((p) => (
            <div key={p.id} className={`${card} p-4 sm:p-5`} data-testid={`product-row-${p.id}`}>
              <div className="flex flex-wrap items-center gap-4">
                <img src={p.img?.startsWith("http") ? p.img : `${process.env.REACT_APP_BACKEND_URL}${p.img || ""}`} alt="" className="h-12 w-16 rounded-lg object-cover" />
                <div className="min-w-0 flex-1">
                  <p className="font-display text-lg text-dusk">{p.title}</p>
                  <p className="text-xs text-stone-500">{p.shop_name} • {p.craft || "—"} • {p.price}</p>
                </div>
                <Pill s={p.pstatus} />
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                <button onClick={() => goCustomer("shop", p.shop_name, p.shop_key)} className={`${btn} bg-dusk text-sand`} data-testid={`product-view-${p.id}`}>View</button>
                <button disabled={busy === p.id} onClick={() => act(p.id, "approve")} className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid={`product-approve-${p.id}`}>Approve</button>
                <button disabled={busy === p.id} onClick={() => act(p.id, "reject")} className={`${btn} border border-stone-300 text-stone-600 hover:bg-stone-100`} data-testid={`product-reject-${p.id}`}>Reject</button>
                <button disabled={busy === p.id} onClick={() => act(p.id, "hide")} className={`${btn} border border-red-300 text-red-600 hover:bg-red-50`} data-testid={`product-hide-${p.id}`}>Hide</button>
                <button onClick={() => { setEdit(edit === p.id ? null : p.id); setF({ title: p.title, price: p.price, price_num: p.price_num }); }} className={`${btn} border border-gold text-dusk hover:bg-gold hover:text-white`} data-testid={`product-edit-${p.id}`}>Edit</button>
              </div>
              {edit === p.id && (
                <div className="mt-4 grid gap-3 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4 sm:grid-cols-3" data-testid="product-edit-form">
                  <label className="text-xs text-stone-500 sm:col-span-2">নাম<input className={input} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></label>
                  <label className="text-xs text-stone-500">দাম (সংখ্যায়)<input className={input} value={f.price_num ?? ""} onChange={(e) => setF({ ...f, price_num: e.target.value })} /></label>
                  <button onClick={save} disabled={busy === p.id} className={`${btn} bg-vermilion text-white sm:col-span-3`} data-testid="product-edit-save">সাধুন</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- লোকশিল্পী ---------- */
export function ArtistsTab({ goCustomer }) {
  const [q, setQ] = useState("");
  const [d, load] = useList(`/admin/artists?q=${encodeURIComponent(q)}`);
  const [busy, setBusy] = useState("");
  const [edit, setEdit] = useState(null);
  const [f, setF] = useState({});

  const act = async (id, action) => {
    setBusy(id); try { await adminFetch(`/admin/artists/${id}/action`, { method: "POST", body: JSON.stringify({ action }) }); load(); } catch (e) { alert(e.message); } setBusy("");
  };
  const save = async () => {
    setBusy(edit);
    try {
      await adminFetch(`/admin/artists/${edit}`, { method: "PUT", body: JSON.stringify(f) });
      setEdit(null); load();
    } catch (e) { alert(e.message); }
    setBusy("");
  };

  return (
    <div data-testid="admin-section-artists">
      <Toolbar q={q} setQ={setQ} />
      {!d ? <Loading /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((a) => (
            <div key={a.id} className={`${card} p-4 sm:p-5`} data-testid={`artist-row-${a.id}`}>
              <div className="flex flex-wrap items-center gap-4">
                <img src={a.profile_img?.startsWith("http") ? a.profile_img : `${process.env.REACT_APP_BACKEND_URL}${a.profile_img || ""}`} alt="" className="h-12 w-12 rounded-full object-cover ring-2 ring-gold/40" />
                <div className="min-w-0 flex-1">
                  <p className="font-display text-lg text-dusk">{a.name}</p>
                  <p className="text-xs text-stone-500">{a.art_form} • {a.location} • {a.price_display}</p>
                </div>
                <Pill s={a.status} />
              </div>
              <div className="mt-3 flex flex-wrap gap-2">
                <button onClick={() => goCustomer("moncho", "রং ও মঞ্চ")} className={`${btn} bg-dusk text-sand`} data-testid={`artist-view-${a.id}`}>View Stage</button>
                <button disabled={busy === a.id} onClick={() => act(a.id, "approve")} className={`${btn} bg-emerald-600 text-white hover:bg-emerald-700`} data-testid={`artist-approve-${a.id}`}>Approve</button>
                {a.status === "স্থগিত"
                  ? <button disabled={busy === a.id} onClick={() => act(a.id, "approve")} className={`${btn} border border-gold text-dusk hover:bg-gold hover:text-white`} data-testid={`artist-reactivate-${a.id}`}>আবার চালু</button>
                  : <button disabled={busy === a.id} onClick={() => act(a.id, "suspend")} className={`${btn} border border-red-300 text-red-600 hover:bg-red-50`} data-testid={`artist-suspend-${a.id}`}>Suspend</button>}
                <button
                  onClick={() => { setEdit(edit === a.id ? null : a.id); setF({ art_form: a.art_form || "", location: a.location || "", price_display: a.price_display || "" }); }}
                  className={`${btn} border border-gold text-dusk hover:bg-gold hover:text-white`}
                  data-testid={`artist-edit-${a.id}`}
                >
                  Edit
                </button>
              </div>
              {edit === a.id && (
                <div className="mt-4 grid gap-3 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4 sm:grid-cols-3" data-testid="artist-edit-form">
                  <label className="text-xs text-stone-500">শিল্প-ঘরানা<input className={input} value={f.art_form} onChange={(e) => setF({ ...f, art_form: e.target.value })} /></label>
                  <label className="text-xs text-stone-500">ঠিকানা<input className={input} value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} /></label>
                  <label className="text-xs text-stone-500">শুরুর দাম (লেখা)<input className={input} value={f.price_display} onChange={(e) => setF({ ...f, price_display: e.target.value })} /></label>
                  <button onClick={save} disabled={busy === a.id} className={`${btn} bg-vermilion text-white sm:col-span-3`} data-testid="artist-edit-save">সাধুন</button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- অর্ডার ---------- */
const ORDER_ST = ["নতুন", "নিশ্চিত", "তৈরি হচ্ছে", "পাঠানো হয়েছে", "সম্পন্ন", "বাতিল"];
export function OrdersTab() {
  const [q, setQ] = useState("");
  const [d, load] = useList(`/admin/orders?q=${encodeURIComponent(q)}`);
  const change = async (code, status) => {
    try { await adminFetch(`/admin/orders/${encodeURIComponent(code)}/status`, { method: "POST", body: JSON.stringify({ status }) }); load(); } catch (e) { alert(e.message); }
  };
  return (
    <div data-testid="admin-section-orders">
      <Toolbar q={q} setQ={setQ} />
      {!d ? <Loading /> : d.items.length === 0 ? <Empty text="এখনো কোনো অর্ডার-রসিদ আসেনি।" /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((o) => (
            <div key={o.code} className={`${card} p-4 sm:p-5`} data-testid={`order-row-${o.code}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-display text-lg text-dusk">{o.code}</p>
                  <p className="text-sm text-stone-600">{o.name} • {o.phone}</p>
                  <p className="mt-1 text-xs text-stone-500">{(o.items || []).map((i) => `${i.title} — ${i.price}`).join(" | ")}</p>
                  <p className="mt-1 text-[11px] text-stone-400">{(o.ts || "").slice(0, 10)}</p>
                </div>
                <select value={o.status || "নতুন"} onChange={(e) => change(o.code, e.target.value)} className={sel} data-testid={`order-status-${o.code}`}>
                  {ORDER_ST.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- বুকিং ---------- */
const BOOKING_ST = ["নতুন", "শিল্পীর জবাব", "প্রস্তুত", "নিশ্চিত", "সম্পন্ন", "বাতিল"];
export function BookingsTab() {
  const [q, setQ] = useState("");
  const [d, load] = useList(`/admin/bookings?q=${encodeURIComponent(q)}`);
  const [open, setOpen] = useState(null);
  const change = async (code, status) => {
    try { await adminFetch(`/admin/bookings/${encodeURIComponent(code)}/status`, { method: "POST", body: JSON.stringify({ status }) }); load(); } catch (e) { alert(e.message); }
  };
  return (
    <div data-testid="admin-section-bookings">
      <Toolbar q={q} setQ={setQ} />
      {!d ? <Loading /> : d.items.length === 0 ? <Empty text="এখনো কোনো মঞ্চ-বুকিং আসেনি।" /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((b) => (
            <div key={b.code} className={`${card} p-4 sm:p-5`} data-testid={`booking-row-${b.code}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0 cursor-pointer" onClick={() => setOpen(open === b.code ? null : b.code)}>
                  <p className="font-display text-lg text-dusk">{b.code} — {b.performer}</p>
                  <p className="text-sm text-stone-600">{b.event_type} • {b.date} {b.time || ""} • {b.location} • {b.duration}</p>
                  <p className="text-xs text-stone-500">বাজেট ₹{b.budget_min}–₹{b.budget_max}{b.agreed_price ? ` • চূড়ান্ত ₹${b.agreed_price}` : ""}{b.last_artist_price ? ` • শিল্পীর শেষ কথা ₹${b.last_artist_price}` : ""}</p>
                </div>
                <select value={b.status} onChange={(e) => change(b.code, e.target.value)} className={sel} data-testid={`booking-status-${b.code}`}>
                  {[...new Set([...BOOKING_ST, b.status])].filter(Boolean).map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              {open === b.code && (
                <div className="mt-3 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-4 text-sm" data-testid="booking-conversation">
                  <p className="text-[11px] text-stone-400">গ্রাহক-কথা</p>
                  <p className="text-dusk">{b.name} • {b.phone} • দর্শক {b.audience || "—"}</p>
                  {b.note && <p className="mt-1 text-stone-600">খুঁটিনাটি: {b.note}</p>}
                  <p className="mt-2 text-[11px] text-stone-400">দর-কথার গতি</p>
                  <p className="text-dusk">{b.rounds || 0} ধাপ • শিল্পীর সর্বশেষ {b.last_artist_price ? `₹${b.last_artist_price}` : "—"}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- জিজ্ঞেস ---------- */
export function EnquiriesTab() {
  const [d, load] = useList("/admin/enquiries");
  const change = async (qid, status) => {
    try { await adminFetch(`/admin/enquiries/${encodeURIComponent(qid)}/status`, { method: "POST", body: JSON.stringify({ status }) }); load(); } catch (e) { alert(e.message); }
  };
  return (
    <div data-testid="admin-section-enquiries">
      {!d ? <Loading /> : d.items.length === 0 ? <Empty text="এখনো কোনো জিজ্ঞেস আসেনি।" /> : (
        <div className="space-y-3">
          {d.items.map((q) => (
            <div key={q.enquiry_id} className={`${card} p-4 sm:p-5`} data-testid={`enquiry-row-${q.enquiry_id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="text-sm text-dusk">{q.name} • {q.phone}</p>
                  <p className="mt-1 text-sm text-stone-600">{q.message}</p>
                  <p className="mt-1 text-[11px] text-stone-400">{(q.items || []).map((i) => i.title).join(", ")} • {(q.ts || "").slice(0, 10)}</p>
                </div>
                <select value={q.status || "নতুন"} onChange={(e) => change(q.enquiry_id, e.target.value)} className={sel} data-testid={`enquiry-status-${q.enquiry_id}`}>
                  <option value="নতুন">নতুন</option><option value="চলছে">চলছে</option><option value="done">মেটানো</option>
                </select>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- AI-দরদাম ---------- */
export function AiSalesTab() {
  const [q, setQ] = useState("");
  const [d, load] = useList(`/admin/ai-sales?q=${encodeURIComponent(q)}`);
  const [busy, setBusy] = useState("");
  const flip = async (pid, off) => {
    setBusy(pid); try { await adminFetch(`/admin/ai-sales/${pid}/override`, { method: "POST", body: JSON.stringify({ off }) }); load(); } catch (e) { alert(e.message); } setBusy("");
  };
  return (
    <div data-testid="admin-section-aisales">
      <Toolbar q={q} setQ={setQ} />
      <p className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs leading-relaxed text-amber-800">
        AI বন্ধ করলে সেই পণ্যের প্রতিনিধি শুধু নম্র জবাব দেবে — দরদাম বা বুদ্ধি দুটোই থেমে যাবে। প্রতিটা ওভাররাইড কার্যক্রম-খাতায় ওঠে।
      </p>
      {!d ? <Loading /> : (
        <div className="mt-4 space-y-3">
          {d.items.map((r) => (
            <div key={r.pid} className={`${card} p-4 sm:p-5`} data-testid={`ai-row-${r.pid}`}>
              <div className="flex flex-wrap items-center gap-4">
                <div className="min-w-0 flex-1">
                  <p className="font-display text-lg text-dusk">{r.title}</p>
                  <p className="text-xs text-stone-500">{r.shop} • তালিকা ₹{Number(r.listed).toLocaleString("en-IN")} • সুরক্ষিত ন্যূনতম ₹{Number(r.min_price).toLocaleString("en-IN")}</p>
                  <p className="text-[11px] text-stone-400">শেষ সাধ: {(r.ai_updated_at || "").slice(0, 10) || "—"}</p>
                </div>
                <Pill s={r.ai_status} />
                <button disabled={busy === r.pid} onClick={() => flip(r.pid, !r.ai_off)}
                  className={`${btn} ${r.ai_off ? "bg-emerald-600 text-white hover:bg-emerald-700" : "border border-red-300 text-red-600 hover:bg-red-50"}`}
                  data-testid={`ai-toggle-${r.pid}`}>
                  {r.ai_off ? "AI চালু করুন" : "AI বন্ধ করুন"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- প্রচার ---------- */
export function PromotionsTab() {
  const [d, load] = useList("/admin/promotions");
  const [f, setF] = useState({ name: "", kind: "shops", ref: "", start: "", end: "" });
  const [err, setErr] = useState("");
  const add = async () => {
    setErr("");
    try { await adminFetch("/admin/promotions", { method: "POST", body: JSON.stringify(f) }); setF({ name: "", kind: "shops", ref: "", start: "", end: "" }); load(); }
    catch (e) { setErr(e.message); }
  };
  const del = async (pid) => { try { await adminFetch(`/admin/promotions/${pid}`, { method: "DELETE" }); load(); } catch (e) { alert(e.message); } };
  const kinds = { shops: "প্রাণবন্ত দোকান", products: "বিশেষ পণ্য", artists: "বিশেষ শিল্পী", events: "উৎসব-অনুষ্ঠান" };
  return (
    <div data-testid="admin-section-promotions">
      <div className={`${card} p-5`}>
        <h3 className="font-display text-lg text-dusk">নতুন প্রচার</h3>
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <label className="text-xs text-stone-500">নাম<input className={input} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="promo-name" /></label>
          <label className="text-xs text-stone-500">ধরন
            <select className={input} value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} data-testid="promo-kind">
              {Object.entries(kinds).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
          <label className="text-xs text-stone-500">যাকে ঘিরে (দোকান-চিহ্ন/পণ্য/শিল্পী-আইডি)<input className={input} value={f.ref} onChange={(e) => setF({ ...f, ref: e.target.value })} data-testid="promo-ref" /></label>
          <div className="grid grid-cols-2 gap-2">
            <label className="text-xs text-stone-500">শুরু<input type="date" className={input} value={f.start} onChange={(e) => setF({ ...f, start: e.target.value })} /></label>
            <label className="text-xs text-stone-500">শেষ<input type="date" className={input} value={f.end} onChange={(e) => setF({ ...f, end: e.target.value })} /></label>
          </div>
        </div>
        <button onClick={add} className={`${btn} mt-4 bg-vermilion text-white`} data-testid="promo-add">প্রচার বসান</button>
        {err && <p className="mt-2 text-xs text-red-600">{err}</p>}
      </div>
      {!d ? <Loading /> : d.items.length === 0 ? <div className="mt-4"><Empty text="এখনো কোনো প্রচার বসানো হয়নি।" /></div> : (
        <div className="mt-4 space-y-3">
          {d.items.map((p) => (
            <div key={p.id} className={`${card} flex flex-wrap items-center justify-between gap-3 p-4`} data-testid={`promo-row-${p.id}`}>
              <div>
                <p className="font-display text-lg text-dusk">{p.name}</p>
                <p className="text-xs text-stone-500">{kinds[p.kind] || p.kind} • {p.start || "—"} থেকে {p.end || "—"} • {p.status}</p>
              </div>
              <button onClick={() => del(p.id)} className={`${btn} border border-red-300 text-red-600 hover:bg-red-50`} data-testid={`promo-del-${p.id}`}>সরান</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ---------- কনটেন্ট (গ্রামের লেখা-ছবি) — আগের যাচাই-করা সাধুনি আবার ব্যবহার ---------- */
export function ContentTab() {
  const [d, setD] = useState(null);
  const load = () => adminFetch("/admin/site").then(setD).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-section-content">
      <p className="mb-4 rounded-xl border border-[#e6dcc8] bg-[#fdfaf4] p-3 text-xs text-stone-500">
        গ্রামের স্বাগতম, মার্কি, দোকান-পণ্য-মঞ্চের লেখাছবি — এখান থেকে সাধলেই দর্শকের পোর্টালে সঙ্গে সঙ্গে পড়ে।
      </p>
      {d ? <SiteContent data={d} refresh={load} /> : <Loading />}
    </div>
  );
}

/* ---------- রিপোর্ট ---------- */
export function ReportsTab() {
  const [d, setD] = useState(null);
  useEffect(() => { adminFetch("/admin/reports").then(setD).catch(() => {}); }, []);
  if (!d) return <Loading />;
  const rows = [
    ["ক্রিয়েটর-বৃদ্ধি", `${d.creator_growth?.total ?? 0} জন (এ মাসে ${d.creator_growth?.this_month ?? 0})`],
    ["প্রাণবন্ত দোকান", d.live_shops],
    ["প্রাণবন্ত শিল্পী", d.live_artists],
    ["পণ্য", d.products],
    ["অর্ডার", d.orders],
    ["বুকিং", d.bookings],
    ["জিজ্ঞেস", d.enquiries],
    ["লেনদেন-মান (নিশ্চিত বুকিং)", `₹${Number(d.transaction_value || 0).toLocaleString("en-IN")}`],
  ];
  return (
    <div data-testid="admin-section-reports">
      <div className={`${card} divide-y divide-[#efe6d4]`}>
        {rows.map(([k, v]) => (
          <div key={k} className="flex items-center justify-between px-5 py-3.5">
            <span className="text-sm text-stone-500">{k}</span>
            <span className="font-display text-lg text-dusk">{v}</span>
          </div>
        ))}
      </div>
      {d.note && <p className="mt-3 text-xs text-stone-400">{d.note}</p>}
    </div>
  );
}

/* ---------- সেটিংস ---------- */
export function SettingsTab({ me }) {
  const [d, setD] = useState(null);
  const [f, setF] = useState(null);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const load = () => adminFetch("/admin/settings").then((x) => { setD(x); setF({ categories: (x.categories || []).join(", "), languages: (x.languages || []).join(", "), commission: x.commission || "", maintenance: x.maintenance }); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const superU = me?.role === "admin";

  const save = async () => {
    setMsg(""); setErr("");
    try {
      await adminFetch("/admin/settings", {
        method: "PUT",
        body: JSON.stringify({
          categories: f.categories.split(",").map((s) => s.trim()).filter(Boolean),
          languages: f.languages.split(",").map((s) => s.trim()).filter(Boolean),
          commission: f.commission,
          maintenance: f.maintenance,
        }),
      });
      setMsg("সেটিংস জমা হয়েছে — খাতায় ওঠে।"); load();
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="space-y-6" data-testid="admin-section-settings">
      {!f ? <Loading /> : (
        <div className={`${card} p-5`}>
          <div className="flex items-center justify-between">
            <h3 className="font-display text-lg text-dusk">প্ল্যাটফর্ম-সেটিংস</h3>
            {!superU && <span className="rounded-full border border-stone-300 px-3 py-1 text-[11px] text-stone-500">শুধু মুখ্য-প্রশাসক পাল্টাতে পারেন</span>}
          </div>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            <label className="text-xs text-stone-500">ঘরানা-তালিকা (কমায়)<input className={input} disabled={!superU} value={f.categories} onChange={(e) => setF({ ...f, categories: e.target.value })} data-testid="settings-categories" /></label>
            <label className="text-xs text-stone-500">ভাষা-তালিকা (কমায়)<input className={input} disabled={!superU} value={f.languages} onChange={(e) => setF({ ...f, languages: e.target.value })} data-testid="settings-languages" /></label>
            <label className="text-xs text-stone-500">কমিশন-নোট (স্থানধারক)<input className={input} disabled={!superU} value={f.commission} placeholder="যেমন ১০% — এখনো চালু নয়" onChange={(e) => setF({ ...f, commission: e.target.value })} data-testid="settings-commission" /></label>
            <label className="flex items-center gap-2 text-xs text-stone-500 sm:mt-6">
              <input type="checkbox" disabled={!superU} checked={f.maintenance} onChange={(e) => setF({ ...f, maintenance: e.target.checked })} className="h-4 w-4 accent-[#C83E2B]" data-testid="settings-maintenance" />
              গ্রাম-রক্ষণাবেক্ষণ চালু (প্রোটোটাইপ-নোট)
            </label>
          </div>
          <button onClick={save} disabled={!superU} className={`${btn} mt-4 bg-vermilion text-white`} data-testid="settings-save">জমান</button>
          {msg && <p className="mt-2 text-xs text-emerald-700">{msg}</p>}
          {err && <p className="mt-2 text-xs text-red-600">{err}</p>}
        </div>
      )}
      <div className={`${card} p-5`}>
        <h3 className="font-display text-lg text-dusk">আমার পাসওয়ার্ড</h3>
        <PasswordForm />
      </div>
    </div>
  );
}

/* ---------- কার্যক্রম-খাতা ---------- */
export function AuditTab() {
  const [d, setD] = useState(null);
  useEffect(() => { adminFetch("/admin/audit").then(setD).catch(() => {}); }, []);
  if (!d) return <Loading />;
  return (
    <div data-testid="admin-section-audit">
      {d.items.length === 0 ? <Empty text="খাতা এখনো ফাঁকা — কোনো প্রশাসক-কাজ হয়নি।" /> : (
        <div className={`${card} divide-y divide-[#efe6d4]`}>
          {d.items.map((a, i) => (
            <div key={i} className="flex flex-wrap items-center justify-between gap-2 px-5 py-3" data-testid="audit-row">
              <div className="min-w-0">
                <p className="text-sm text-dusk">{a.detail || a.action}</p>
                <p className="text-[11px] text-stone-400">{a.admin} • {a.action} {a.obj ? `• ${a.obj}` : ""}</p>
              </div>
              <span className="text-[11px] text-stone-400">{(a.ts || "").slice(0, 16).replace("T", " ")}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
